import useSmallUnfavourite from '@/hooks/carpi/useSmallUnfavourite';
import useTranslations from '@/hooks/useTranslations';
import { StarButton } from './StarButton';
import { WorkflowCategories } from '@/types/fragments';

interface props {
  id: string;
  loading?: boolean;
  product: WorkflowCategories;
}

export default function SmallFavourite({ id, loading, product }: props) {
  const { handleUnfavouriting } = useSmallUnfavourite({ id, product });
  const { t } = useTranslations();

  return (
    <StarButton
      onClick={handleUnfavouriting}
      leftPosition={false}
      border={false}
      backgroundColor={false}
      isFavourited={false}
      ariaLabel={t('cards.favourite')}
      smallStar={false}
      disabled={loading}
    />
  );
}
